var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWifi = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#102A56",
  fillRule: "evenodd",
  d: "M8 3.834c-2.073 0-4.084.83-5.652 2.347a.5.5 0 1 1-.696-.72C3.398 3.774 5.655 2.834 8 2.834s4.602.94 6.348 2.629a.5.5 0 1 1-.696.719C12.084 4.663 10.073 3.834 8 3.834m.023 3.11c-1.329 0-2.622.511-3.655 1.456a.5.5 0 1 1-.675-.739c1.209-1.105 2.74-1.716 4.33-1.716s3.12.611 4.33 1.716a.5.5 0 0 1-.675.739c-1.033-.945-2.327-1.455-3.655-1.455m-.02 3.112a2.7 2.7 0 0 0-1.663.584.5.5 0 1 1-.615-.788 3.7 3.7 0 0 1 2.278-.796 3.7 3.7 0 0 1 2.278.796.5.5 0 0 1-.615.788 2.7 2.7 0 0 0-1.663-.584m-.503 2.61a.5.5 0 0 1 .5-.5h.006a.5.5 0 0 1 0 1H8a.5.5 0 0 1-.5-.5",
  clipRule: "evenodd"
})));
export default SvgWifi;